import { useEffect } from 'react';
import { history } from '@umijs/max';
import type { AppInitialState } from '../types';
import { useUserManagement } from './useUserManagement';
import { useMenuManagement } from './useMenuManagement';

export const useAppCore = (
    initialState: AppInitialState,
    setInitialState: (state: AppInitialState | ((prev: AppInitialState) => AppInitialState)) => void
) => {
    const { shouldFetchUserInfo, loginPath } = useUserManagement();
    const { refreshUserMenu, fetchUserMenu } = useMenuManagement(initialState, setInitialState);

    // 清除用户数据和菜单信息
    const clearUserData = () => {
        setInitialState((prev) => ({
            ...prev,
            currentUser: undefined,
            currentUserMenu: undefined,
            menuLastUpdated: undefined,
            showGoogle2FAModal: false,
        }));
    };



    // 页面变化时的路由保护
    const handlePageChange = () => {
        const { location } = history;
        // 如果没有登录，重定向到 login
        if (!initialState?.currentUser && location.pathname !== loginPath) {
            history.push(loginPath);
        }
    };

    // 获取用户信息后立即获取菜单
    useEffect(() => {
        if (initialState?.currentUser && !initialState?.currentUserMenu) {
            refreshUserMenu();
        }
    }, [initialState?.currentUser, refreshUserMenu]);

    return {
        handlePageChange,
        loginPath,
        clearUserData,
    };
};
